import { Action, Dispatch } from "redux";
import axios from "../../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import * as action_types from "./constants";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getCompanyFieldsById = (payload: { company_id: string }) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getCompanyFieldsById`,
        payload
      );
      dispatch({
        type: action_types.TAGS_CATEGORIES,
        data: { payload: data?.data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.TAGS_CATEGORIES,
        payload: { loading: false },
      });
    }
  };
};

export const removeCompanyFieldsByIdData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.TAGS_CATEGORIES,
      data: { payload: {}, loading: true },
    });
  };
};
